export const FORM_SHARES_BASE_URL = 'form-shares';
